import { Spinner } from "react-bootstrap";

export interface BlockLoaderProps {
    loadingText?: string | null;
}

const BlockLoader: React.FC<BlockLoaderProps> = ({ loadingText }) => {
    return (
        <div className="block-loader fade-in-animation">
            <Spinner as="span" animation="border" size="sm" />
            <div>{loadingText ?? "Please wait..."}</div>
        </div>
    );
};

export default BlockLoader;
